import { IAnalyticsProperties } from 'components/Button/types';
import { ITextProps } from 'components/MultipleChoice/types';

export const ANALYTICS_SOURCE = 'who-is-this-application-for';
export const CURRENT_USER = 'myself';
export const SOMEONE_ELSE = 'someone else';
export const LOG_OUT = 'Log out';

export const BUTTON_ANALYTICS_PROPERTIES: IAnalyticsProperties = {
  source: ANALYTICS_SOURCE,
  text: 'Continue',
};

export const HEADER = 'Help us personalize your search';
export const SUBHEADER: ITextProps = {
  id: 'select-user-subheader',
  text: 'Who are you shopping for?',
};

export const SELF_PLAYBACK = "Great - we'll save this application to your account.";
export const SOMEONE_ELSE_PLAYBACK =
  "Great. We'll create a new account and save this application for them to access later.";
